export enum BulkExportFormatte {
  PivotExcelXLSX = "xlsx",
  FlatFileCSV = "csv",
  FlatFileTXT = "txt",
  Default = PivotExcelXLSX
}